import type React from "react";
import { Button } from "@/components/ui/button";
interface ContextMenuProps {
  x: number;
  y: number;
  onDeleteNode?: () => void;
  onAddNode?: () => void;
}
export const ContextMenu: React.FC<ContextMenuProps> = ({
  x,
  y,
  onDeleteNode,
  onAddNode
}) => {
  return <div className="absolute z-50 rounded border bg-background p-2 shadow-md" style={{
    top: y,
    left: x
  }} data-sentry-component="ContextMenu" data-sentry-source-file="ContextMenu.tsx">
      {onAddNode && <Button variant="ghost" className="w-full justify-start" onClick={onAddNode}>
          Add Node
        </Button>}
      {onDeleteNode && <Button variant="ghost" className="w-full justify-start text-destructive" onClick={onDeleteNode}>
          Delete Node
        </Button>}
    </div>;
};